import styled from 'styled-components';

export const WrapContent = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 12px 12px 0 0;
  padding: 18px 0;

  ::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }
`;

export const WrapListProduct = styled.div`
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }
`;

export const WrapItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px 0;
  width: 100%;
  justify-content: space-between;

  .ant-radio-wrapper {
    margin: 0 !important;
  }
`;

export const WrapRating = styled.div`
  display: flex;
  padding-top: 6px;
  align-items: center;
  width: 100%;
`;

export const HeaderPopup = styled.div`
  width: 100%;
`;

export const HeaderTitlePopup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
`;
